import React from 'react';
import { useAuth } from '../context/AuthContext';
import { needsTrackmanSyncNotice, RECRUITING_BLOCKED_MESSAGE } from '../utils/trackmanAccess';
import './BlurredUnavailable.css';

// Wraps a whole page (Portal, JUCO Leaderboard) and, for real (non-demo), non-Admin South
// Alabama accounts (see utils/trackmanAccess), renders it blurred and non-interactive behind a
// "not available" message instead of blocking the route outright — so the page's own shape is
// still visible, it just can't be read or used. Every other account sees children unchanged.
function BlurredUnavailable({ children }) {
  const { currentUser } = useAuth();
  if (!needsTrackmanSyncNotice(currentUser)) return children;
  return (
    <div className="blurred-unavailable-wrap">
      <div className="blurred-unavailable-content" aria-hidden="true">
        {children}
      </div>
      <div className="blurred-unavailable-overlay">
        <div className="blurred-unavailable-message" role="note">
          {RECRUITING_BLOCKED_MESSAGE}
        </div>
      </div>
    </div>
  );
}

export default BlurredUnavailable;
